<!-- Main content Start -->
<div class="main-content">
  <!--Full width header Start-->
  <div class="full-width-header home8-style4 home9">
    <home-main-menu></home-main-menu>
  </div>
  <!--Full width header End-->
  <!-- Banner Section Start -->
  <div id="rs-banner" class="rs-banner style8">
    <div class="container">
      <div class="banner-content">
        <div class="sl-sub-title wow bounceInLeft" data-wow-delay="300ms" data-wow-duration="2000ms">Welcome To</div>
        <h1 class="sl-title wow fadeInRight" data-wow-delay="600ms" data-wow-duration="2000ms">Swamy Vivekananda Degree & PG College</h1>
        <div class="sl-btn wow fadeInUp" data-wow-delay="900ms" data-wow-duration="2000ms">
          <a class="readon yellow-btn" href="#">Discover More</a>
        </div>
      </div>
    </div>
  </div>
  <!-- Banner Section End -->
  <!-- Features Section start -->
  <div id="rs-features" class="rs-features style2">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 md-mb-30">
          <div class="rs-iconbox-area">
            <div class="icon-area">
              <img src="assets/college/Image1.png" alt="">
            </div>
            <div class="text-area">
              <h3 class="icon-title">Future Students</h3>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 md-mb-30">
          <div class="rs-iconbox-area">
            <div class="icon-area">
              <img src="assets/college/Image2.png" alt="">
            </div>
            <div class="text-area">
              <h3 class="icon-title">World Students</h3>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 sm-mb-30">
          <div class="rs-iconbox-area">
            <div class="icon-area">
              <img src="assets/college/Image3.png" alt="">
            </div>
            <div class="text-area">
              <h3 class="icon-title">Current Students</h3>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="rs-iconbox-area">
            <div class="icon-area">
              <img src="assets/college/Image4.png" alt="">
            </div>
            <div class="text-area">
              <h3 class="icon-title">Alumni & Donors</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Features Section End -->
  <!-- About Section Start -->
  <div class="rs-about style9 pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12 md-mb-40">
          <div class="img-part js-tilt">
            <img src="assets/college/SVDPGBUILDING.jpg" alt="Swamy Vivekananda Degree & PG College">
          </div>
        </div>
        <div class="col-lg-6 pl-100 md-pl-15 col-md-12">
          <div class="content">
            <div class="sub-title mb-20">
              About Us
            </div>
            <h2 class="sl-title mb-40 md-mb-20">
              Welcome To Swamy Vivekananda Degree & PG College
            </h2>
            <p class="desc mb-50">
              Swamy Vivekananda degree & P.G College has been established under Sri Balaji Educational Society, Kalyanadurgam for the academic year 2006-2007. Dr. Palle Raghunatha Reddy garu, former Minister in the Govt of A.P and a recipient of 10 national service awards, is the founder and Correspondent of this prestigious educational Society. Being an academician himself, and with the motto of providing unmatched and quality educational to the students of Kalyanadurgam, Dr.Palle Raghunatha Reddy upgraded the Degree College to P.G. level in Anantapur District.
            </p>
           
          </div>
          <div class="btn-part">
            <a class="readon yellow-btn" [routerLink]="['/about/college']" routerLinkActive="active">Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- About Section End -->
  <!-- Video Section Start -->
  <div class="rs-video-home9">
    <div class="img-part media-icon yellow-color">
      <a class="popup-videos" href="http://www.youtube.com/@swamyvivekananda5547" target="_blank" rel="noopener noreferrer">
        <i class="fa fa-play"></i>
      </a>
    </div>
  </div>
  <!-- Video Section End -->
  <!-- Blog Section Start -->
  <div id="rs-blog" class="rs-blog home9-style event2-bg pt-94 pb-100 md-pt-64 md-pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 col-md-12 pr-75 md-pr-15 md-mb-50">
          <div class="sec-title3 mb-50 md-mb-30">
            <div class="sub-title yellow-color">News</div>
            <h2 class="title black-color">Latest News</h2>
          </div>
          <div class="row align-items-center no-gutter white-bg blog-item mb-30 wow fadeInUp" data-wow-delay="300ms" data-wow-duration="2000ms">
            <div class="col-md-6">
              <div class="image-part">
                <a href="#"><img src="assets/images/blog/1.jpg" alt=""></a>
              </div>
            </div>
            <div class="col-md-6">
              <div class="blog-content">
                <ul class="blog-meta">
                  <li><i class="fa fa-calendar-check-o"></i>August 28, 2020</li>
                </ul>
                <h3 class="title"><a href="#">Pandemic drives millions from Latin America’s</a></h3>
                <p class="txt">We denounce with righteous indige nation and...</p>
              </div>
            </div>
          </div>
          <div class="row align-items-center no-gutter white-bg blog-item mb-30 wow fadeInUp" data-wow-delay="400ms" data-wow-duration="2000ms">
            <div class="col-md-6">
              <div class="image-part">
                <a href="#"><img src="assets/images/blog/2.jpg" alt=""></a>
              </div>
            </div>
            <div class="col-md-6">
              <div class="blog-content">
                <ul class="blog-meta">
                  <li><i class="fa fa-calendar-check-o"></i>August 28, 2020</li>
                </ul>
                <h3 class="title"><a href="#">This is a great source of content for anyone…</a></h3>
                <p class="txt">We denounce with righteous indige nation and...</p>
              </div>
            </div>
          </div>
          <div class="row align-items-center no-gutter white-bg blog-item wow fadeInUp" data-wow-delay="500ms" data-wow-duration="2000ms">
            <div class="col-md-6">
              <div class="image-part">
                <a href="#"><img src="assets/images/blog/3.jpg" alt=""></a>
              </div>
            </div>
            <div class="col-md-6">
              <div class="blog-content">
                <ul class="blog-meta">
                  <li><i class="fa fa-calendar-check-o"></i>August 19, 2020</li>
                </ul>
                <h3 class="title"><a href="#">Shutdown of schools extended to Aug 31</a></h3>
                <p class="txt">We denounce with righteous indige nation and...</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 lg-pl-0">
          <div class="sec-title3 mb-50 md-mb-30">
            <div class="sub-title yellow-color">Events</div>
            <h2 class="title black-color">Latest Events</h2>
          </div>
          <div class="events-short-top mb-30 wow fadeInUp" data-wow-delay="400ms" data-wow-duration="2000ms">
            <div class="date-part">
              <span class="month">June</span>
              <div class="date">20</div>
            </div>
            <div class="content-part">
              <div class="categorie">
                <a href="#">Recipes</a>
              </div>
              <h3 class="title"><a href="#">Spicy Quince And Cranberry Chutney</a></h3>
              <p class="txt">Educavo Events Description Lorem ipsum dolor sit amet, consectetuer...</p>
            </div>
          </div>
          <div class="events-short-top mb-30 wow fadeInUp" data-wow-delay="400ms" data-wow-duration="2000ms">
            <div class="date-part">
              <span class="month">June</span>
              <div class="date">20</div>
            </div>
            <div class="content-part">
              <div class="categorie">
                <a href="#">Recipes</a>
              </div>
              <h3 class="title"><a href="#">Persimmon, Pomegranate, And Massaged Kale Salad</a></h3>
              <p class="txt">Educavo Events Description Lorem ipsum dolor sit amet, consectetuer...</p>
            </div>
          </div>
          <div class="events-short-top wow fadeInUp" data-wow-delay="500ms" data-wow-duration="2000ms">
            <div class="date-part">
              <span class="month">June</span>
              <div class="date">20</div>
            </div>
            <div class="content-part">
              <div class="categorie">
                <a href="#">Recipes</a>
              </div>
              <h3 class="title"><a href="#">Essential Fall Fruits That Aren’t Apples</a></h3>
              <p class="txt">Educavo Events Description Lorem ipsum dolor sit amet, consectetuer...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Blog Section End -->
  <!-- Categories Section Start -->
  <div id="rs-categories" class="rs-categories home9-style event-bg pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="sec-title3 text-center mb-45">
        <div class="sub-title yellow-color">Our Expert Team Members</div>
        <h2 class="title black-color">Strength of our College is our dedicated Team of Members</h2>
      </div>
      <div class="row team-members-row">
        <div class="col-lg-3 md-mb-40">
          <div class="categories-items">
            <div class="images-part">
              <a href="#"><img src="https://jntuanotifications.blob.core.windows.net/websites/profiles/Dr_Palle_Raghunatha_Reddy.png" alt=""></a>
            </div>
            <div class="image-content">
              <div class="effect-icon">
                <i class="fa fa-graduation-cap"></i>
              </div>
              <div class="title">
                <a href="#">Dr. Palle Raghunatha Reddy</a>
              </div>
              <div class="description">
                <p class="text-center">Founder, Correspondent & Secretary</p>
                <p class="text-center">
                  Sri Balaji Educational Society
                </p>
              </div>
              <div class="button-bottom">

              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 md-mb-40">
          <div class="categories-items">
            <div class="images-part">
              <a href="#"><img src="https://jntuanotifications.blob.core.windows.net/websites/profiles/Dr_Palle_Venkata_Krishna_Kishore.png" alt=""></a>
            </div>
            <div class="image-content">

              <div class="title">
                <a href="#">Dr. Palle Venkata Krishna Kishore Reddy</a>
              </div>
              <div class="description">
                <div class="effect-icon">
                  <i class="fa fa-graduation-cap"></i>
                </div>
                <p class="text-center">Chairman</p>
                <p class="text-center">
                  Sri Balaji Educational Society
                </p>
              </div>
              <div class="button-bottom">

              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="categories-items">
            <div class="images-part">
              <a href="#"><img src="https://jntuanotifications.blob.core.windows.net/websites/profiles/Smt_Palle_Sindhura_Reddy.png" alt=""></a>
            </div>
            <div class="image-content">
              <div class="effect-icon">
                <i class="fa fa-graduation-cap"></i>
              </div>
              <div class="title">
                <a href="#">Smt. Palle Sindhura Reddy</a>
              </div>
              <div class="description">
                <p class="text-center">Treasurer</p>
                <p class="text-center">
                  Sri Balaji Educational Society
                </p>
                <p class="text-center">
                  MLA - Puttaparthi Constituency, AP
                </p>
              </div>
              <div class="button-bottom">

              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="categories-items">
            <div class="images-part">
              <a href="#"><img src="assets/college/principal.jfif" alt=""></a>
            </div>
            <div class="image-content">
              <div class="effect-icon">
                <i class="fa fa-graduation-cap"></i>
              </div>
              <div class="title">
                <a href="#">T.Ramalingappa</a>
              </div>
              <div class="description">
                <p class="text-center">Principal</p>
                <p class="text-center">
                  Swamy Vivekananda Degree & PG College
                </p>

              </div>
              <div class="button-bottom">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Categories Section End -->
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

